/**
 * Frontend subscription limits.
 *
 * Keep plan-specific UI limits in this file. Backend security and billing checks
 * must still enforce the same policy server-side; client-side checks are only a
 * convenience for disabling actions and explaining why they are unavailable.
 */

export const FREE_PLAN_ID = 'free' as const;

export interface SubscriptionLimits {
  /** Maximum number of novels owned by the user. */
  ownedNovels: number | null;
  /** Maximum number of characters in each novel. */
  charactersPerNovel: number | null;
  /** Maximum number of locations in each novel. */
  locationsPerNovel: number | null;
  /** Maximum number of organizations in each novel. */
  organizationsPerNovel: number | null;
  /** Maximum number of events in each novel. */
  eventsPerNovel: number | null;
}

/** `null` means unlimited. */
export const FREE_SUBSCRIPTION_LIMITS = Object.freeze({
  ownedNovels: 1,
  charactersPerNovel: 5,
  locationsPerNovel: 5,
  organizationsPerNovel: 3,
  eventsPerNovel: 10,
} satisfies SubscriptionLimits);

export type FreeSubscriptionLimit = keyof typeof FREE_SUBSCRIPTION_LIMITS;

export function isFreeSubscription(planId?: string | null): boolean {
  return !planId || planId === FREE_PLAN_ID;
}

export function hasReachedFreeSubscriptionLimit(
  limit: FreeSubscriptionLimit,
  currentCount: number,
): boolean {
  return currentCount >= FREE_SUBSCRIPTION_LIMITS[limit];
}
